import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import './smallTab.less'
import classNames from 'classnames'

export default ({ options = [], value, onChange }) => {
  const cutIndex = options.findIndex(item => value === item.value)
  const curItem = cutIndex !== -1 ? options[cutIndex] : options[0]
  return <div className="mn-switch-small-tab">
    <div
      className={classNames('mn-switch-small-tab-prev fill-white-bg', { disabled: cutIndex === 0 })}
      onClick={() => {
        if (cutIndex !== 0) {
          onChange(options[cutIndex - 1].value, options[cutIndex - 1])
        }
      }}
    ><Icon type="m-Vxing_zuo" /></div>
    {curItem.label}
    <div
      className={classNames('mn-switch-small-tab-next fill-white-bg', { disabled: options.length === cutIndex + 1 })}
      onClick={() => {
        if (options.length !== cutIndex + 1) {
          onChange(options[cutIndex + 1].value, options[cutIndex + 1])
        }
      }}
    ><Icon type="m-Vxing_you" /></div>
  </div>
}
